<template>
	<b-modal
		v-model="opened"
		header-class="header-class-modal-doc-package"
		size="xl"
		cancel-variant="outline-primary"
		button-size="md"
		:ok-title="isActionCrud === addData ? FormMSG(26, 'Add day to timesheet') : FormMSG(76, 'Update day to timesheet')"
		:cancel-title="FormMSG(27, 'Cancel')"
		ok-variant="primary"
		hide-header-close
		no-close-on-backdrop
		no-close-on-esc
		:ok-disabled="disableFieldByStatus"
		@ok.prevent="saveCurDay"
		@show="editData && isEditMode"
		@hidden="hideModalAddUpdate"
	>
		<template #modal-header="{}">
			<div class="d-flex flex-row w-100">
				<div class="d-flex flex-row w-100">
					<h5>{{ isActionCrud === addData ? FormMSG(25, 'Add work') : FormMSG(77, 'Update work') }}</h5>
				</div>
				<div class="d-flex flex-row w-100">
					<div v-if="isEditMode && editData !== null" class="d-flex w-80 align-items-center justify-content-end w-100">
						<span v-if="!isFilmSingle" class="border-encoded p-1">
							{{ FormMSG(283, 'Encoded by: ') }} <b>{{ encoder(editData) }}</b>
						</span>
					</div>
					<div :class="editData && isEditMode ? 'w-20' : 'w-100'">
						<button class="btn-close" type="button" @click="hideModalAddUpdate()">×</button>
					</div>
				</div>
			</div>
		</template>
		<form-time-card
			use-form-for="web"
			:time-cards="TsDays"
			:time-card-to-edit="editData.tsDay"
			hide-alert
			:hide-status="hideStatusFormTimeCard"
			:multiple-selection-date="mutlipleSelectionDateFormTimeCard"
			hide-save-btn
			:hide-person-selector="false"
			:hide-department-selector="false"
			:is-my-time-card="false"
			:use-form-in-modal="useFormInModal"
			:screen-used-the-form="screenUsedTheForm"
			:user-id="currUserId"
			:submit-form="submitForm"
			:disable-user-select="update"
			:external-dates="externalDates"
			:use-view-planning="useViewPlanning"
			:is-action-crud="isActionCrud"
			@form-time-card:udpate-date="getTsDays"
			@form-time-card:save-cur-day-success="handleFormTimeCardSubmitSuccess"
			@form-time-card:close-cur-day="handleFormTimeCardSubmitPresistent"
			@form-time-card:empty-list="handleFormTimeCardEmptyList"
			@senddataAuthToSubmitFormSelectMultiple="senddataAuthToSubmitFormSelectMultiple"
		/>
	</b-modal>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import GlobalMixin from '@/mixins/global.mixin';
import moment from 'moment';
import { getUsers } from '../../cruds/users.crud';
import { saveTsDaysForCrew } from '@/cruds/timesheet.crud';
import { ACTION_EFC_TIMESHEET } from '@/utils/utils';
import { classStatus } from '@/shared/global-status';
import FormTimeCard from '@/components/Work/FormTimeCard';
import { getProjectUserTsDays } from '@/cruds/timesheets-efc.crud.js';
import { VALIDATION_TYPE } from '@/shared/constants';
import _ from 'lodash';

export default {
	name: 'TimeCardForCrewModal',
	components: { FormTimeCard },

	mixins: [languageMessages, isSingleProjectMixin, GlobalMixin],

	props: {
		update: {
			type: Boolean,
			default: false,
			required: false
		},
		isOpen: {
			type: Boolean,
			default: false
		},
		editData: {
			type: Object,
			default: null,
			required: false
		},
		isActionCrud: {
			type: String,
			required: false,
			default: ''
		},
		useFormInModal: {
			type: Boolean,
			required: false,
			default: true
		},
		screenUsedTheForm: {
			type: String,
			required: false,
			default: ''
		},
		externalDates: {
			type: Array,
			default: () => [],
			required: false
		}
	},

	data() {
		const { addData, updateData, deleteData } = ACTION_EFC_TIMESHEET;
		return {
			contract: {
				defaultDayType: 0,
				hotelPerDiem: 0,
				lunchPerDiem: 0,
				lunchMinimum: 60,
				totMinPerDay: 480 // DEFAULT 8 HOUR WORK
			},
			department: '',
			curMonthStr: `${moment().format('YYYY')}-${moment().format('MM')}`,
			curDay: {
				id: 0,
				date: moment().format('YYYY-MM-DD') + 'T00:00:00Z',
				strTime: 'T08:00:00Z',
				endTime: 'T18:00:00Z',
				leftHomeAt: 'T07:00:00Z',
				returnedHomeAt: 'T19:00:00Z',
				totMin: 0,
				notSpecifiedLunch: false,
				lunchStrTime: 'T12:00:00Z',
				lunchEndTime: 'T13:00:00Z',
				lunch: false,
				hotel: false,
				useDinner: false,
				useAbroad: false,
				stageDayUsed: false,
				dayType: 0,
				validated: 0,
				kgCoTwo: 0,
				validatedStatus: 'Not Submited',
				hours: '',
				minutes: '',
				hoursOvertime: '',
				minutesOvertime: '',
				hoursOvertime1: '',
				minutesOvertime1: '',
				hoursOvertime2: '',
				minutesOvertime2: '',
				hoursTransportTimePaid: '',
				minutesTransportTimePaid: '',
				hoursNight: '',
				minutesNight: '',
				hoursTooEarly: '',
				minutesTooEarly: '',
				salary: 0,
				hhmm: '',
				hhmmOvt: '',
				hhmmOvt1: '',
				hhmmOvt2: '',
				hhmmTransport: '',
				hhmmNight: '',
				hhmmTooEarly: '',
				comment: '',
				statusClass: 'not-submitted',
				useMileageToSet: false,
				transportFromHomeToWork: false
			},
			DATA_INIT: this.curDay,
			valueCurDayFromDb: false,
			userList: [],
			allDepartements: [],
			selectedUser: [],
			currentMonth: '',
			addData,
			updateData,
			deleteData,
			dataToUpdate: {},
			classStatus,
			isValidate: false,

			// VALIDATION DEPARTMENT
			validationDepartments: [],
			TsDays: [],

			hideStatusFormTimeCard: true,
			mutlipleSelectionDateFormTimeCard: true,
			currUserId: null,
			submitForm: false,
			useViewPlanning: false,
			dataAuthToSubmitForm: [],
			VALIDATION_TYPE
		};
	},
	computed: {
		disableFieldByStatus() {
			return [VALIDATION_TYPE.SUBMITTED, VALIDATION_TYPE.VALIDATED_LEVEL_1, VALIDATION_TYPE.VALIDATED_LEVEL_2].includes(this.editData.status);
		},
		opened: {
			get: function () {
				return this.isOpen;
			},
			set: function (val) {
				return val;
			}
		},
		optionsForDefaultDayType() {
			return this.FormMenu(1010);
		},
		isEditMode() {
			if (this.isActionCrud === this.updateData) {
				return Object.keys(this.editData).length !== 0;
			}
			return false;
		}
	},
	watch: {
		editData: {
			async handler(newVal) {
				if (newVal && Object.keys(newVal).length > 0) {
					const data = {
						id: +newVal.tsDay.id,
						date: moment(newVal.tsDay.date).format('YYYY-MM-DD'),
						strTime: newVal.tsDay.strTime,
						userId: newVal.tsDay.user.id,
						endTime: newVal.tsDay.endTime,
						leftHomeAt: newVal.tsDay.leftHomeAt,
						returnedHomeAt: newVal.tsDay.returnedHomeAt,
						totMin: 0,
						notSpecifiedLunch: newVal.tsDay.notSpecifiedLunch,
						lunchStrTime: newVal.tsDay.lunchStrTime,
						lunchEndTime: newVal.tsDay.lunchEndTime,
						lunch: newVal.tsDay.lunch,
						hotel: newVal.tsDay.hotel,
						useDinner: newVal.tsDay.useDinner,
						useAbroad: newVal.tsDay.useAbroad,
						stageDayUsed: newVal.tsDay.stageDayUsed,
						dayType: newVal.tsDay.dayType,
						validated: newVal.tsDay.validated,
						kgCoTwo: newVal.tsDay.kgCoTwo,
						validatedStatus: this.getLabelStatus(newVal.status),
						hours: newVal.tsDay.hours,
						minutes: newVal.tsDay.minutes,
						hoursOvertime: newVal.tsDay.hoursOvertime,
						minutesOvertime: newVal.tsDay.minutesOvertime,
						hoursOvertime1: newVal.tsDay.hoursOvertime1,
						minutesOvertime1: newVal.tsDay.minutesOvertime1,
						hoursOvertime2: newVal.tsDay.hoursOvertime2,
						minutesOvertime2: newVal.tsDay.minutesOvertime2,
						hoursTransportTimePaid: newVal.tsDay.hoursTransportTimePaid,
						minutesTransportTimePaid: newVal.tsDay.minutesTransportTimePaid,
						hoursNight: newVal.tsDay.hoursNight,
						minutesNight: newVal.minutesNight,
						hoursTooEarly: newVal.tsDay.hoursTooEarly,
						minutesTooEarly: this.minutesTooEarly,
						salary: newVal.tsDay.salary,
						hhmm: newVal.tsDay.hours + newVal.tsDay.minutes,
						hhmmOvt: `${
							+newVal.tsDay.hoursOvertime < 10
								? '0' + newVal.tsDay.hoursOvertime
								: newVal.tsDay.hoursOvertime + ':' + newVal.tsDay.minutesOvertime
						}`,
						hhmmOvt1: '',
						hhmmOvt2: '',
						hhmmTransport: `${
							+newVal.tsDay.hoursTransportTimePaid < 10
								? '0' + newVal.tsDay.hoursTransportTimePaid
								: newVal.tsDay.hoursTransportTimePaid + ':' + newVal.tsDay.minutesTransportTimePaid
						}`,
						hhmmNight: `${
							+newVal.tsDay.hoursNight < 10 ? '0' + newVal.tsDay.hoursNight : newVal.tsDay.hoursNight + ':' + newVal.tsDay.minutesNight
						}`,
						hhmmTooEarly: `${
							+newVal.tsDay.hoursTooEarly < 10
								? '0' + newVal.tsDay.hoursTooEarly
								: newVal.tsDay.hoursTooEarly + ':' + newVal.tsDay.minutesTooEarly
						}`,
						comment: '',
						statusClass: this.classStatus(newVal.status),
						useMileageToSet: newVal.tsDay.useMileageToSet,
						transportFromHomeToWork: newVal.tsDay.transportFromHomeToWork
					};
					for (let i = 0; i < this.allDepartements.length; i++) {
						if (this.newVal.tsDay.departmentName.toUpperCase() === this.allDepartements[i].message.toUpperCase()) {
							this.department = this.allDepartements[i].value;
						}
					}
					this.dataToUpdate = data;
					this.curDay = data;

					this.currUserId = parseInt(newVal.tsDay.user.id, 10);
					await this.getTsDays({ currMonthStr: '' });
				}
			},
			immediate: true,
			deep: true
		},
		externalDates: {
			handler(newVal) {
				if (newVal.length > 0) {
					this.useViewPlanning = true;
				} else {
					this.useViewPlanning = false;
				}
			},
			immediate: true,
			deep: true
		},
		isOpen: {
			handler() {
				if (this.isOpen && this.isActionCrud === this.addData) {
					// this.firstTimeInitialisation();
					return this.isOpen;
				}
			}
		}
		/**
		 * The back button always appear when doing this.
		 */
		// update: {
		// 	handler(newVal) {
		// 		if (newVal) {
		// 			this.hideStatusFormTimeCard = false;
		// 			this.mutlipleSelectionDateFormTimeCard = false;
		// 		}
		// 	},
		// 	immediate: true
		// }
	},
	async created() {
		this.$nextTick(async () => {
			//moment.locale(getLangISOByIndex(store.appLanguage()).two);
			this.currentMonth = moment().format('MMMM');
			if (this.isActionCrud === this.addData) {
				// this.firstTimeInitialisation();
			}
			await this.reloadData();
		});
	},
	methods: {
		encoder(data) {
			return `${data.tsDay.encoder.firstName} ${data.tsDay.encoder.name}`;
		},
		async handleFormTimeCardSubmitSuccess(e) {
			this.$emit('add:Submitted', e);
			this.hideModalAddUpdate();
		},
		handleFormTimeCardSubmitPresistent() {
			this.submitForm = false;
		},
		async handleFormTimeCardEmptyList() {
			this.submitForm = false;
			this.hideModalAddUpdate();
		},
		async getTsDays({ currMonthStr = '' }) {
			if (this.editData.tsDay) {
				let StartDate = '';
				if (currMonthStr === '') {
					StartDate = moment(new Date(this.editData.tsDay.strTime)).format('YYYY-MM');
				} else {
					StartDate = currMonthStr;
				}

				StartDate += '-01T00:00:00+00:00';

				this.TsDays = [];
				const result = await getProjectUserTsDays({
					personId: parseInt(this.editData.tsDay.user.id, 10),
					startDate: StartDate
				});

				result.map((res) => {
					let data = this.updateTZdataEach(res.tsDay);
					this.TsDays.push({ ...res.tsDay, ...data });
				});
			}
		},
		validatedText(validated) {
			// returns the label text corresponding to the validated value from mixin function
			return this.GetTextFromMenuNumberAndMenuValue(1008, validated);
		},
		validatedColor(validated) {
			if (validated == VALIDATION_TYPE.SUBMITTED) {
				var retval = 'primary';
			} else if (validated == VALIDATION_TYPE.VALIDATED_LEVEL_1) {
				var retval = 'warning';
			} else if (validated == VALIDATION_TYPE.VALIDATED_LEVEL_2) {
				var retval = 'success';
			} else if (validated == VALIDATION_TYPE.REFUSED_LEVEL_1 || validated == VALIDATION_TYPE.REFUSED_LEVEL_2) {
				var retval = 'danger';
			} else {
				var retval = 'info';
			}
			return retval;
		},
		updateTZdataEach(timeData) {
			if (_.isNil(timeData)) return;
			// setting row color
			////console.log("timeData.endTime:",timeData.endTime);
			timeData.validatedStatus = this.validatedText(timeData.validated);
			// https://bootstrap-vue.js.org/docs/reference/color-variants
			timeData._rowVariant = ''; //this.validatedColor(timeData.validated);
			timeData.validatedClass = this.validatedColor(timeData.validated);
			timeData.statusClass = classStatus(timeData.validated);
			//console.log("timeData.strTime before:",timeData.strTime);
			// format to local time
			timeData.strTime = moment(timeData.strTime).format();
			timeData.endTime = moment(timeData.endTime).format();
			timeData.lunchStrTime = moment(timeData.lunchStrTime).format();
			timeData.lunchEndTime = moment(timeData.lunchEndTime).format();
			timeData.leftHomeAt = moment(timeData.leftHomeAt).format();
			timeData.returnedHomeAt = moment(timeData.returnedHomeAt).format();
			//console.log("timeData.strTime after:",timeData.strTime);
			timeData.hhmm = timeData.hours + ':' + timeData.minutes;
			timeData.hhmmOvt = timeData.hoursOvertime + ':' + timeData.minutesOvertime;
			timeData.hhmmOvt1 = timeData.hoursOvertime1 + ':' + timeData.minutesOvertime1;
			timeData.hhmmOvt2 = timeData.hoursOvertime2 + ':' + timeData.minutesOvertime2;
			timeData.hhmmTransport = timeData.hoursTransportTimePaid + ':' + timeData.minutesTransportTimePaid;
			timeData.hhmmNight = timeData.hoursNight + ':' + timeData.minutesNight;
			timeData.hhmmTooEarly = timeData.hoursTooEarly + ':' + timeData.minutesTooEarly;

			timeData.hotelPerDiem = timeData.contract.hotelPerDiem;
			timeData.lunchPerDiem = timeData.contract.lunchPerDiem;
			timeData.dinnerPerDiem = timeData.contract.dinnerPerDiem;
			timeData.abroadPerDiem = timeData.contract.abroadPerDiem;
			//console.log("this.contract:",this.contract)

			timeData.isSelected = false;
			timeData.showDetails = false;
		},
		async reloadData() {
			await this.initModalUser();
		},
		async initModalUser() {
			await getUsers({ myProject: true }).then((users) => {
				users.forEach((user) => {
					user.value = user.id;
					user.message = user.fullName;
				});
				this.userList = [
					...users.sort((a, b) => {
						if (a.fullName.toUpperCase() < b.fullName.toUpperCase()) return -1;
						if (a.fullName.toUpperCase() > b.fullName.toUpperCase()) return 1;
						return 0;
					})
				].map((item) => ({ value: item.id, message: item.fullName, userId: item.id, departementId: item.department }));
			});
		},
		async addUpdateItemData() {
			// add and update item
			const curDayDate = this.curDay.date;
			this.curDay.date = this.curDay.date.substring(0, 10);

			let StrTime = this.curDay.strTime;
			let EndTime = this.curDay.endTime;
			if (EndTime < StrTime) {
				alert(this.FormMSG(1111, 'End time is before start time!'));
				return;
			}
			let LeftHomeAt = this.curDay.leftHomeAt;
			let ReturnedHomeAt = this.curDay.returnedHomeAt;

			if (this.curDay.transportFromHomeToWork == false) {
				LeftHomeAt = StrTime;
				ReturnedHomeAt = EndTime;
			}

			if (this.curDay.returnedHomeAt < this.curDay.endTime) {
				this.curDay.returnedHomeAt = this.curDay.endTime;
			}

			if (this.curDay.leftHomeAt > this.curDay.strTime) {
				this.curDay.leftHomeAt = this.curDay.strTime;
			}

			if (ReturnedHomeAt < LeftHomeAt) {
				alert(this.FormMSG(1112, 'Returned home time is before left home time!'));
				return;
			}
			let LunchStrTime = this.curDay.lunchStrTime;
			let LunchEndTime = this.curDay.lunchEndTime;

			if (LunchStrTime === LunchEndTime || this.curDay.notSpecifiedLunch) {
				LunchStrTime = StrTime;
				LunchEndTime = StrTime;
			}

			if (LunchEndTime < LunchStrTime) {
				alert(this.FormMSG(1113, 'Lunch end time is before lunch start time!'));
				return;
			}

			if (this.showStageDay() && this.curDay.stageDayUsed) {
				StrTime = moment(this.curDay.date).add(8, 'hours').format();
				EndTime = null;
			} else {
				this.curDay.useStageDay = false;
			}

			let Lunch = false;
			if (this.curDay.lunch == true) {
				Lunch = true;
			}

			let Hotel = false;
			if (this.curDay.hotel == true) {
				Hotel = true;
			}

			let UseDinner = false;
			if (this.curDay.useDinner == true) {
				UseDinner = true;
			}

			let UseAbroad = false;
			if (this.curDay.useAbroad == true) {
				UseAbroad = true;
			}

			let UseMileageToSet = false;
			if (this.curDay.useMileageToSet == true) {
				UseMileageToSet = true;
			}

			const DayType = this.curDay.dayType;
			this.disableSaveButton = true;
			const NotSpecifiedLunch = this.curDay.notSpecifiedLunch;
			const TransportFromHomeToWork = this.curDay.transportFromHomeToWork;
			let UserId = [];
			if (this.isActionCrud === this.updateData) {
				UserId.push(+this.curDay.userId);
			} else {
				this.selectedUser.map((usr) => {
					UserId.push(parseInt(usr.value, 10));
				});
			}
			await saveTsDaysForCrew(
				curDayDate,
				StrTime,
				EndTime,
				LunchStrTime,
				LunchEndTime,
				Lunch,
				Hotel,
				UseDinner,
				UseAbroad,
				DayType,
				LeftHomeAt,
				ReturnedHomeAt,
				NotSpecifiedLunch,
				UseMileageToSet,
				TransportFromHomeToWork,
				UserId
			)
				.then(async (result) => {
					await this.reloadData();
					if (this.isActionCrud === this.updateData) {
						this.$emit('refresh:dataItem', this.dataToUpdate);
					}
					this.disableSaveButton = false;
					this.createToastForMobile(
						this.FormMSG(162, 'Success'),
						this.isActionCrud === this.addData ? this.FormMSG(39, 'timesheet added to Timesheet!') : this.FormMSG(40, 'timesheet updated!'),
						''
					);
				})
				.catch((error) => {
					this.disableSaveButton = false;
					if (error.message.includes('no valid contract on this day')) {
						var errStr = this.FormMSG(251, 'There is no valid contract for this day');
						alert(errStr);
					} else {
						this.erreur = error;
						alert("Internal error (check network and if user's contract is valid)");
					}
				});
		},
		senddataAuthToSubmitFormSelectMultiple(arrays) {
			const { dates, persons, department, selectTypeMulti, useViewPlanning } = arrays;
			this.dataAuthToSubmitForm = {
				dates: dates,
				persons: persons !== null ? persons : '',
				department: department !== null ? department : '',
				selectTypeMulti: selectTypeMulti,
				useViewPlanning: useViewPlanning
			};
		},
		saveCurDay() {
			if (
				(this.isActionCrud === this.addData && this.dataAuthToSubmitForm.dates.length !== 0 && this.dataAuthToSubmitForm.persons.length !== 0) ||
				(this.isActionCrud === this.addData && this.dataAuthToSubmitForm.dates.length !== 0 && this.dataAuthToSubmitForm.department.length !== 0)
			) {
				this.submitForm = true;
			}
			if (this.dataAuthToSubmitForm.dates.length !== 0 && this.dataAuthToSubmitForm.useViewPlanning === true) {
				this.submitForm = true;
			}
			if (this.isActionCrud === this.updateData) {
				this.submitForm = true;
			}
		},
		hideModalAddUpdate() {
			this.resetData();
			this.$emit('closeModal');
		},
		resetData() {
			const { addData, updateData, deleteData } = ACTION_EFC_TIMESHEET;
			this.contract = {
				defaultDayType: 0,
				hotelPerDiem: 0,
				lunchPerDiem: 0,
				lunchMinimum: 60,
				totMinPerDay: 480
			};

			this.department = '';
			this.curDay = {
				id: 0,
				date: moment().format('YYYY-MM-DD') + 'T00:00:00Z',
				strTime: 'T08:00:00Z',
				userId: '',
				endTime: 'T18:00:00Z',
				leftHomeAt: 'T07:00:00Z',
				returnedHomeAt: 'T19:00:00Z',
				totMin: 0,
				notSpecifiedLunch: false,
				lunchStrTime: 'T12:00:00Z',
				lunchEndTime: 'T13:00:00Z',
				lunch: false,
				hotel: false,
				useDinner: false,
				useAbroad: false,
				stageDayUsed: false,
				dayType: 0,
				validated: 0,
				kgCoTwo: 0,
				validatedStatus: 'Not Submited',
				hours: '',
				minutes: '',
				hoursOvertime: '',
				minutesOvertime: '',
				hoursOvertime1: '',
				minutesOvertime1: '',
				hoursOvertime2: '',
				minutesOvertime2: '',
				hoursTransportTimePaid: '',
				minutesTransportTimePaid: '',
				hoursNight: '',
				minutesNight: '',
				hoursTooEarly: '',
				minutesTooEarly: '',
				salary: 0,
				hhmm: '',
				hhmmOvt: '',
				hhmmOvt1: '',
				hhmmOvt2: '',
				hhmmTransport: '',
				hhmmNight: '',
				hhmmTooEarly: '',
				comment: '',
				statusClass: 'not-submitted',
				useMileageToSet: false,
				transportFromHomeToWork: false
			};
			this.DATA_INIT = this.curDay;
			this.valueCurDayFromDb = false;
			this.selectedUser = [];
			this.currentMonth = '';
			this.addData = addData;
			this.updateData = updateData;
			this.deleteData = deleteData;
			this.dataToUpdate = {};
			this.classStatus = classStatus;
			this.isValidate = false;

			this.validationDepartments = [];
			this.TsDays = [];

			this.hideStatusFormTimeCard = true;
			this.mutlipleSelectionDateFormTimeCard = true;
			this.currUserId = null;
			this.submitForm = false;
			this.useViewPlanning = false;
			// this.firstTimeInitialisation();
		},
		getLabelStatus(value) {
			return this.GetTextFromMenuNumberAndMenuValue(1008, value);
		}
	}
};
</script>

<style scoped>
.btn-close {
	background-color: transparent;
	border: 0;
	float: right;
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	opacity: 0.5;
}
.border-encoded {
	border: 2px solid #cad0d7;
	border-radius: 5px;
}
</style>
